import React, {FC, PropsWithChildren} from 'react';

import {
  BrowserContext,
  BrowserContextProps,
} from '../../libs/shared/ui/src/components/browser/browserContext';
import {openInBrowser} from './openInBrowser';

const contextValue: BrowserContextProps = {
  openInBrowser,
};

export const BrowserProvider: FC<PropsWithChildren> = ({children}) => (
  <BrowserContext.Provider value={contextValue}>{children}</BrowserContext.Provider>
);
